module.exports = __webpack_public_path__ + "static/img/4.34e7fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/4.png
// module id = Be7E
// module chunks = 0